<script setup lang="ts">
import { TabsContent as RadixTabsContent } from 'radix-vue'

const props = defineProps<{
  value: string
  class?: string
}>()
</script>

<template>
  <RadixTabsContent
    :value="props.value"
    :class="['outline-none focus-visible:ring-2 ring-blue-500', props.class]"
  >
    <slot />
  </RadixTabsContent>
</template>
